import { memo } from "react";
import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";
import {
  BlockOutlined,
  CheckCircleOutline,
  ErrorOutline,
  RemoveCircleOutline,
  ScheduleOutlined,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { BULK_STATUS, BULK_STATUS_COLOR } from "./constants";

const ICONS = {
  [BULK_STATUS.waiting]: ScheduleOutlined,
  [BULK_STATUS.eligible]: ScheduleOutlined,
  [BULK_STATUS.unsupported]: BlockOutlined,
  [BULK_STATUS.assigned]: CheckCircleOutline,
  [BULK_STATUS.failed]: ErrorOutline,
  [BULK_STATUS.stopped]: RemoveCircleOutline,
  [BULK_STATUS.alreadyAssigned]: CheckCircleOutline,
};

function BulkStatusCell({ status, errorMsg, companyName, currentStatus }) {
  const { t } = useTranslation();
  const color = BULK_STATUS_COLOR[status] ?? "text.primary";

  const isBusy =
    status === BULK_STATUS.checking || status === BULK_STATUS.assigning;

  // A failure carries the server's own message; everything else has a fixed
  // label. `errorMsg` goes through t() because the backend sometimes returns a
  // translation key rather than a sentence.
  let label;
  if (status === BULK_STATUS.failed && errorMsg) {
    label = t(errorMsg);
  } else if (status === BULK_STATUS.alreadyAssigned) {
    // Show the order's real status, using the labels the shipments list uses.
    label = currentStatus
      ? t(`mapit-ship-status.${currentStatus}`)
      : t("bulkAssign.status.alreadyAssigned");
  } else if (status === BULK_STATUS.unsupported) {
    label = t("bulkAssign.notAvailableForOrder", { company: companyName });
  } else {
    label = t(`bulkAssign.status.${status}`);
  }

  const Icon = ICONS[status];

  return (
    <Tooltip title={label} placement="top">
      <Box display="flex" alignItems="center" gap={0.75} sx={{ minWidth: 0 }}>
        {isBusy ? (
          <CircularProgress size={16} />
        ) : (
          Icon && <Icon sx={{ fontSize: 18, color }} />
        )}
        <Typography noWrap variant="subtitle2" sx={{ color, maxWidth: "100%" }}>
          {label}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default memo(BulkStatusCell);
